import * as React from "react"
import {Skeleton} from "@mui/material";
import {AmchartSeeker} from "@ui-seeker/core";

import {TitleWithPopover} from "@components";
import { useCatalogueAnalyzerPriceNumProductsChart } from "./@hooks";
import CatalogueAnalyzerPriceNumProductsToolbar from "./Toolbar";


export default function CatalogueAnalyzerPriceNumProductsChart() {
    
	const { isLoading, data, selectOptions, selectValue, handleChangeOptions, title } = useCatalogueAnalyzerPriceNumProductsChart()
	
	if (isLoading) return <Skeleton variant="rectangular" height={500} />
	if (!data.length) return <></>
	
	return <AmchartSeeker
		rootID="catalogueEvolution"
		title={<TitleWithPopover title="Product-Price Mix by Site" />}
		data={data}
		series={[{
			name: 'Nº Products',
			yField: `numProducts`,
			xField: "retailer",
			type: 'column'
		}]}
		seriesRev={[{
			name: 'Avg Price',
			yField: `avgPrice`,
			xField: "retailer",
			tooltip: {
                labelText: "Avg Price: {avgPrice} {currency}" 
            }
		}]}
		chartProps={{
			numberFormat: `#,###`,
			chart: {
				maxTooltipDistance: 0,
			},
			xAxis: {
				categoryField: 'retailer'
			}
		}}
		cardProps={{ actions: <CatalogueAnalyzerPriceNumProductsToolbar value={selectValue} options={selectOptions} handleChangeOption={handleChangeOptions}  /> }}
	/>
}
